import styled from 'styled-components'
import theme from '@theme'

const H1 = styled.h1`
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 500;
  color: ${theme.font.primary};

  .sub-title {
    color: ${theme.font.secondary};
  }
`

export default H1
